module.exports = __webpack_public_path__ + "img/icon_map_6_on_100.6beee537.png";